module.exports = __webpack_public_path__ + "img/icon-free.595840ae.png";